import type * as data from "../data";
import { InterfaceRef } from "./interfaces";

export * from "../data";


export type Node = data.Node;
export const Node = InterfaceRef.define<Node>("Node", {});


export type List = data.List;
export const List = InterfaceRef.define<List>("List", {});


export type Object = data.Object;
export const Object = InterfaceRef.define<Object>("Object", {});
